<div class="px-3">
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
<g id="bar_chart">
<mask
        id="mask0_4545_22904"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
<rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
</mask>
<g mask="url(#mask0_4545_22904)">
<path
          id="bar_chart_2"
          d="M16 20V13H20V20H16ZM10 20V4H14V20H10ZM4 20V9H8V20H4Z"
          fill="#002987"
        />
</g>
</g>
</svg>
</div>
